export const WARNING_DAYS = Object.freeze({
  MIN: 4,
  MAX: 15,
});